module.exports = {"name":"@dialogexe/cw-component-title","version":"1.1.5","description":"DX CustomWeb Title Component","main":"Title.tsx","scripts":{},"repository":{"type":"git","url":"git+https://github.com/dialogexe/cw-component-title.git"},"keywords":["title"],"author":"DX","license":"ISC","bugs":{"url":"https://github.com/dialogexe/cw-component-title/issues"},"homepage":"https://github.com/dialogexe/cw-component-title#readme","peerDependencies":{"react":"^16.3.2"},"publishConfig":{"registry":"https://npm.pkg.github.com/"}}


//////////////////
// WEBPACK FOOTER
// ./~/@dialogexe/cw-component-title/package.json
// module id = 989
// module chunks = 178422501501999